/** CSS custom property set on :root (by the dunning banner) to the banner's height in px. */
export const BANNER_OFFSET_VAR = '--bt-banner-offset';

/** `top` for a full-viewport fixed overlay so it starts below the banner. */
export const BANNER_OFFSET_TOP = `var(${BANNER_OFFSET_VAR}, 0px)`;

/** `height` for a full-viewport fixed overlay so it ends at the viewport bottom. */
export const BANNER_OFFSET_HEIGHT = `calc(100vh - var(${BANNER_OFFSET_VAR}, 0px))`;

/** Paper `sx` for a full-viewport fixed drawer (MUI paper is `position: fixed; top: 0`) so it starts below the banner. */
export const BANNER_OFFSET_PAPER_SX = {
    top: BANNER_OFFSET_TOP,
    height: BANNER_OFFSET_HEIGHT,
} as const;
